<h1 mat-dialog-title>Badge Editor</h1>
<div mat-dialog-content>
    <div class="flex row">
        <div class="flex flex-40 justify-stretch">
            <mat-selection-list
                [multiple]="false"
                hideSingleSelectionIndicator
                class="flex-100"
                (selectionChange)="selectBadge($event.options[0].value)"
            >
                @for (badge of badges$ | async; track badge) {
                    <mat-list-option [value]="badge">
                        <a matListItemTitle>{{ badge.tag.displayName }}</a>
                        <img matListItemIcon src="{{ badge.image }}" />
                    </mat-list-option>
                }
                <mat-list-option [value]="null">
                    <a matListItemTitle>Add</a>
                    <mat-icon matListItemIcon>add</mat-icon>
                </mat-list-option>
            </mat-selection-list>
        </div>
        <div class="flex flex-60 column justify-end">
            <form [formGroup]="form">
                <div>
                    @if (form.value.tag) {
                        <h3>
                            <mat-icon>label</mat-icon>
                            {{ form.value.tag.displayName }}
                        </h3>
                    } @else {
                        <frog-tag-input
                            (OnSelect)="setTag($event.value)"
                            placeholder="Choose Tag"
                        ></frog-tag-input>
                    }
                </div>
                <div>
                    <input type="file" #file style="display: none" (change)="onFilesAdded()" />
                    <button
                        mat-stroked-button
                        color="accent"
                        class="add-files-btn"
                        (click)="addFiles()"
                    >
                        Choose Image
                    </button>
                </div>
            </form>
            <div class="preview">
                <img class="tag-badge" src="{{ badgeimage || imageurl }}" />
                <img src="assets/bliss.png" width="256" height="256" />
            </div>
            <div>
                <button mat-raised-button [disabled]="!form.valid" (click)="save()" color="primary">
                    Save
                </button>
                <button mat-button [disabled]="!form.value.id" (click)="deleteBadge()" color="warn">
                    Delete
                </button>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]>Close</button>
</div>
